import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { PWAInstallProvider } from './context/PWAInstallContext';
import { dataInitService } from './services/dataInitService';
import { pwaService } from './services/pwaService';
import { injectStore } from './services/syncService';
import { userActivityService } from './services/userActivityService';
import ErrorBoundary from './components/common/ErrorBoundary';

injectStore(store);
userActivityService.setStore(store);
dataInitService.initializeDatabase();
pwaService.initialize(store);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SYNC_REQUEST') {
      import('./services/syncService').then(({ syncService }) => {
        import('./services/networkService').then(({ networkService }) => {
          if (networkService.getNetworkQuality() !== 'offline') {
            syncService.syncAllPendingData().catch(() => { });
          }
        });
      });
    }
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <PWAInstallProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </PWAInstallProvider>
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);